import { ref as v, onMounted as w, onUnmounted as S, defineComponent as T, getCurrentInstance as M, openBlock as A, createElementBlock as O, computed as y } from "vue";
import E from "wavesurfer.js";
const P = ({ containerRef: n, options: e }) => {
  const t = v(null), i = () => {
    n.value && (t.value = E.create({
      container: n.value,
      ...e
    }));
  }, s = () => {
    t.value && (t.value.destroy(), t.value = null);
  };
  return w(() => {
    i();
  }), S(() => {
    s();
  }), { waveSurfer: t };
}, I = (n) => {
  const e = v(!1), t = v(!1), i = v(0), s = v(0), r = () => {
    e.value = !1, t.value = !1, i.value = 0;
  }, o = (m) => {
    e.value = !0, t.value = !1, i.value = 0, s.value = m;
  }, a = () => {
    t.value = !0;
  }, d = () => {
    t.value = !1;
  }, h = () => {
    n.value && (i.value = n.value.getCurrentTime());
  }, l = () => {
    e.value = !1, t.value = !1;
  };
  return w(() => {
    n.value && (n.value.on("load", r), n.value.on("ready", o), n.value.on("play", a), n.value.on("pause", d), n.value.on("timeupdate", h), n.value.on("destroy", l));
  }), S(() => {
    n.value && n.value.unAll();
  }), {
    isReady: e,
    isPlaying: t,
    currentTime: i,
    totalDuration: s
  };
}, k = ({ containerRef: n, options: e }) => {
  const { waveSurfer: t } = P({ containerRef: n, options: e }), { isReady: i, totalDuration: s, isPlaying: r, currentTime: o } = I(t);
  return {
    waveSurfer: t,
    isReady: i,
    totalDuration: s,
    isPlaying: r,
    currentTime: o
  };
}, x = ["audioprocess", "click", "dblclick", "decode", "drag", "finish", "init", "interaction", "load", "loading", "pause", "play", "ready", "redraw", "redrawcomplete", "scroll", "seeking", "timeupdate", "zoom"], U = /* @__PURE__ */ T({
  __name: "WaveSurferPlayer",
  props: {
    options: {}
  },
  setup(n) {
    const e = n, t = v(null), { waveSurfer: i } = k({ containerRef: t, options: e.options }), s = M();
    return w(() => {
      x.forEach((r) => {
        i.value?.on(r, (...o) => {
          s?.emit(r, ...o);
        });
      }), s?.emit("waveSurfer", i.value);
    }), (r, o) => (A(), O("div", {
      ref_key: "containerRef",
      ref: t
    }, null, 512));
  }
});
function W(n, e, t, i) {
  return new (t || (t = Promise))(function(s, r) {
    function o(h) {
      try {
        d(i.next(h));
      } catch (l) {
        r(l);
      }
    }
    function a(h) {
      try {
        d(i.throw(h));
      } catch (l) {
        r(l);
      }
    }
    function d(h) {
      var l;
      h.done ? s(h.value) : (l = h.value, l instanceof t ? l : new t(function(m) {
        m(l);
      })).then(o, a);
    }
    d((i = i.apply(n, [])).next());
  });
}
class b {
  constructor() {
    this.listeners = {};
  }
  on(e, t, i) {
    if (this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set()), this.listeners[e].add(t), i?.once) {
      const s = () => {
        this.un(e, s), this.un(e, t);
      };
      return this.on(e, s), s;
    }
    return () => this.un(e, t);
  }
  un(e, t) {
    var i;
    (i = this.listeners[e]) === null || i === void 0 || i.delete(t);
  }
  once(e, t) {
    return this.on(e, t, { once: !0 });
  }
  unAll() {
    this.listeners = {};
  }
  emit(e, ...t) {
    this.listeners[e] && this.listeners[e].forEach((i) => i(...t));
  }
}
class B extends b {
  constructor(e) {
    super(), this.subscriptions = [], this.options = e;
  }
  onInit() {
  }
  _init(e) {
    this.wavesurfer = e, this.onInit();
  }
  destroy() {
    this.emit("destroy"), this.subscriptions.forEach((e) => e());
  }
}
class _ extends b {
  constructor() {
    super(...arguments), this.unsubscribe = () => {
    };
  }
  start() {
    this.unsubscribe = this.on("tick", () => {
      requestAnimationFrame(() => {
        this.emit("tick");
      });
    }), this.emit("tick");
  }
  stop() {
    this.unsubscribe();
  }
  destroy() {
    this.unsubscribe();
  }
}
const F = ["audio/webm", "audio/wav", "audio/mpeg", "audio/mp4", "audio/mp3"];
class R extends B {
  constructor(e) {
    var t, i, s, r, o, a;
    super(Object.assign(Object.assign({}, e), { audioBitsPerSecond: (t = e.audioBitsPerSecond) !== null && t !== void 0 ? t : 128e3, scrollingWaveform: (i = e.scrollingWaveform) !== null && i !== void 0 && i, scrollingWaveformWindow: (s = e.scrollingWaveformWindow) !== null && s !== void 0 ? s : 5, continuousWaveform: (r = e.continuousWaveform) !== null && r !== void 0 && r, renderRecordedAudio: (o = e.renderRecordedAudio) === null || o === void 0 || o, mediaRecorderTimeslice: (a = e.mediaRecorderTimeslice) !== null && a !== void 0 ? a : void 0 })), this.stream = null, this.mediaRecorder = null, this.dataWindow = null, this.isWaveformPaused = !1, this.lastStartTime = 0, this.lastDuration = 0, this.duration = 0, this.timer = new _(), this.subscriptions.push(this.timer.on("tick", () => {
      const d = performance.now() - this.lastStartTime;
      this.duration = this.isPaused() ? this.duration : this.lastDuration + d, this.emit("record-progress", this.duration);
    }));
  }
  static create(e) {
    return new R(e || {});
  }
  renderMicStream(e) {
    var t;
    const i = new AudioContext(), s = i.createMediaStreamSource(e), r = i.createAnalyser();
    s.connect(r), this.options.continuousWaveform && (r.fftSize = 32);
    const o = r.frequencyBinCount, a = new Float32Array(o);
    let d = 0;
    this.wavesurfer && ((t = this.originalOptions) !== null && t !== void 0 || (this.originalOptions = Object.assign({}, this.wavesurfer.options)), this.wavesurfer.options.interact = !1, this.options.scrollingWaveform && (this.wavesurfer.options.cursorWidth = 0));
    const h = setInterval(() => {
      var l, m, p, g;
      if (!this.isWaveformPaused) {
        if (r.getFloatTimeDomainData(a), this.options.scrollingWaveform) {
          const u = Math.floor((this.options.scrollingWaveformWindow || 0) * i.sampleRate), c = Math.min(u, this.dataWindow ? this.dataWindow.length + o : o), f = new Float32Array(u);
          if (this.dataWindow) {
            const D = Math.max(0, u - this.dataWindow.length);
            f.set(this.dataWindow.slice(-c + o), D);
          }
          f.set(a, u - o), this.dataWindow = f;
        } else if (this.options.continuousWaveform) {
          if (!this.dataWindow) {
            const c = this.options.continuousWaveformDuration ? Math.round(100 * this.options.continuousWaveformDuration) : ((m = (l = this.wavesurfer) === null || l === void 0 ? void 0 : l.getWidth()) !== null && m !== void 0 ? m : 0) * window.devicePixelRatio;
            this.dataWindow = new Float32Array(c);
          }
          let u = 0;
          for (let c = 0; c < o; c++) {
            const f = Math.abs(a[c]);
            f > u && (u = f);
          }
          if (d + 1 > this.dataWindow.length) {
            const c = new Float32Array(2 * this.dataWindow.length);
            c.set(this.dataWindow, 0), this.dataWindow = c;
          }
          this.dataWindow[d] = u, d++;
        } else this.dataWindow = a;
        if (this.wavesurfer) {
          const u = ((g = (p = this.dataWindow) === null || p === void 0 ? void 0 : p.length) !== null && g !== void 0 ? g : 0) / 100;
          this.wavesurfer.load("", [this.dataWindow], this.options.scrollingWaveform ? this.options.scrollingWaveformWindow : u).then(() => {
            this.wavesurfer && this.options.continuousWaveform && (this.wavesurfer.setTime(this.getDuration() / 1e3), this.wavesurfer.options.minPxPerSec || this.wavesurfer.setOptions({ minPxPerSec: this.wavesurfer.getWidth() / this.wavesurfer.getDuration() }));
          }).catch((c) => {
            console.error("Error rendering real-time recording data:", c);
          });
        }
      }
    }, 10);
    return { onDestroy: () => {
      clearInterval(h), s?.disconnect(), i?.close();
    }, onEnd: () => {
      this.isWaveformPaused = !0, clearInterval(h), this.stopMic();
    } };
  }
  startMic(e) {
    return W(this, void 0, void 0, function* () {
      let t;
      try {
        t = yield navigator.mediaDevices.getUserMedia({ audio: !e?.deviceId || { deviceId: e.deviceId } });
      } catch (r) {
        throw new Error("Error accessing the microphone: " + r.message);
      }
      const { onDestroy: i, onEnd: s } = this.renderMicStream(t);
      return this.subscriptions.push(this.once("destroy", i)), this.subscriptions.push(this.once("record-end", s)), this.stream = t, t;
    });
  }
  stopMic() {
    this.stream && (this.stream.getTracks().forEach((e) => e.stop()), this.stream = null, this.mediaRecorder = null);
  }
  startRecording(e) {
    return W(this, void 0, void 0, function* () {
      const t = this.stream || (yield this.startMic(e));
      this.dataWindow = null;
      const i = this.mediaRecorder || new MediaRecorder(t, { mimeType: this.options.mimeType || F.find((o) => MediaRecorder.isTypeSupported(o)), audioBitsPerSecond: this.options.audioBitsPerSecond });
      this.mediaRecorder = i, this.stopRecording();
      const s = [];
      i.ondataavailable = (o) => {
        o.data.size > 0 && s.push(o.data), this.emit("record-data-available", o.data);
      };
      const r = (o) => {
        var a;
        const d = new Blob(s, { type: i.mimeType });
        this.emit(o, d), this.options.renderRecordedAudio && (this.applyOriginalOptionsIfNeeded(), (a = this.wavesurfer) === null || a === void 0 || a.load(URL.createObjectURL(d)));
      };
      i.onpause = () => r("record-pause"), i.onstop = () => r("record-end"), i.start(this.options.mediaRecorderTimeslice), this.lastStartTime = performance.now(), this.lastDuration = 0, this.duration = 0, this.isWaveformPaused = !1, this.timer.start(), this.emit("record-start");
    });
  }
  getDuration() {
    return this.duration;
  }
  isRecording() {
    var e;
    return ((e = this.mediaRecorder) === null || e === void 0 ? void 0 : e.state) === "recording";
  }
  isPaused() {
    var e;
    return ((e = this.mediaRecorder) === null || e === void 0 ? void 0 : e.state) === "paused";
  }
  isActive() {
    var e;
    return ((e = this.mediaRecorder) === null || e === void 0 ? void 0 : e.state) !== "inactive";
  }
  stopRecording() {
    var e;
    this.isActive() && ((e = this.mediaRecorder) === null || e === void 0 || e.stop(), this.timer.stop());
  }
  pauseRecording() {
    var e, t;
    this.isRecording() && (this.isWaveformPaused = !0, (e = this.mediaRecorder) === null || e === void 0 || e.requestData(), (t = this.mediaRecorder) === null || t === void 0 || t.pause(), this.timer.stop(), this.lastDuration = this.duration);
  }
  resumeRecording() {
    var e;
    this.isPaused() && (this.isWaveformPaused = !1, (e = this.mediaRecorder) === null || e === void 0 || e.resume(), this.timer.start(), this.lastStartTime = performance.now(), this.emit("record-resume"));
  }
  static getAvailableAudioDevices() {
    return W(this, void 0, void 0, function* () {
      return navigator.mediaDevices.enumerateDevices().then((e) => e.filter((t) => t.kind === "audioinput"));
    });
  }
  destroy() {
    this.applyOriginalOptionsIfNeeded(), super.destroy(), this.stopRecording(), this.stopMic();
  }
  applyOriginalOptionsIfNeeded() {
    this.wavesurfer && this.originalOptions && (this.wavesurfer.setOptions(this.originalOptions), delete this.originalOptions);
  }
}
const q = ({ containerRef: n, options: e, recordPluginOptions: t }) => {
  const { waveSurfer: i } = P({ containerRef: n, options: e }), s = v(null), r = v(0), o = v(!1), a = v(!1), d = y(() => [
    Math.floor(r.value % 36e5 / 6e4),
    // minutes
    Math.floor(r.value % 6e4 / 1e3)
    // seconds
  ].map((u) => u < 10 ? "0" + u : u).join(":")), h = y(() => o.value || !a.value), l = () => {
    s.value && s.value?.on("record-progress", (u) => {
      r.value = u;
    });
  }, m = () => {
    if (s.value?.isRecording() || s.value?.isPaused()) {
      s.value?.stopRecording(), o.value = !1, a.value = !0;
      return;
    }
    s.value?.startRecording(), o.value = !0, a.value = !1, l();
  }, p = () => new Promise((u) => {
    let c;
    (s.value?.isRecording() || s.value?.isPaused()) && (s.value?.stopRecording(), o.value = !1, a.value = !1), s.value?.on("record-end", (f) => {
      c = f, u(c);
    });
  }), g = () => {
    if (s.value?.isPaused()) {
      s.value?.resumeRecording(), o.value = !0, a.value = !1;
      return;
    }
    o.value = !1, a.value = !0, s.value?.pauseRecording();
  };
  return w(() => {
    const u = i.value?.registerPlugin(R.create({
      renderRecordedAudio: !1,
      ...t
    }));
    u && (s.value = u);
  }), {
    waveSurfer: i,
    waveSurferRecorder: s,
    currentTime: d,
    startRecording: m,
    stopRecording: p,
    pauseRecording: g,
    isRecording: o,
    isPaused: a,
    isPauseResume: h
  };
};
export {
  U as WaveSurferPlayer,
  k as useWaveSurfer,
  q as useWaveSurferRecorder
};
